import React, {Component} from 'react';
import RangeInput from "../common/RangeInput";
import styled from 'styled-components';
import Input from "./Input";

const Block = styled.div`
  margin-bottom: 30px;
  &:last-child{
    margin-bottom: 0;
  }
`;

const Label = styled.div`
  grid-area: l;
  font-weight: 500;
  @include ease;
`;

const Field = styled.div`
`;

const Wrapper = styled.div`
  width: 100%;
`;

const Slider = styled.div`
  width: 100%;
  margin-right: 30px;
`;

const StyledInput = styled(Input)`
  margin-bottom: 7px;
`;

class RadioSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            focused: false,
        };

        this.handleProgressChange = this.handleProgressChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.input = React.createRef();
    }

    handleProgressChange(newProgress) {
        let coercedProgress = newProgress;
        const progressStep = this.props.field.step / (this.props.field.max - this.props.field.min);
        if (coercedProgress < 0) {
            coercedProgress = 0;
        }
        else if (coercedProgress > 1) {
            coercedProgress = 1;
        }
        const steps = Math.round(coercedProgress / progressStep);
        this.handleValueChange(this.props.field.min + (steps * this.props.field.step));
    }

    handleValueChange(value){
        this.props.callback(value ? value : 0);
    }

    render() {
        const name = this.props.name;
        const value = this.props.value;
        const formattedValue = this.props.value + ( this.state.focused ? '' : ' mm' + ' = ' + (this.props.value/1000) + ' m' );
        const field = this.props.field;
        const callback = this.handleValueChange;
        return (
            <Block>
                <Field>
                    <Wrapper>
                        <StyledInput ref={this.input} onFocus={() => {this.setState({
                            focused: true,
                        })}} onBlur={() => { this.setState({
                            focused: false,
                        })}} center={'true'} value={formattedValue} onChange={
                            (e) => callback(e.target.value)

                        }/>
                        <Slider>
                            <RangeInput callback={this.handleProgressChange} value={value} min={field.min} max={field.max}/>
                        </Slider>
                    </Wrapper>
                </Field>
            </Block>
        );
    }
}

export default RadioSelect;
